'use client';

import { ArrowUpRightIcon } from '@heroicons/react/16/solid';
import { ReactNode, useState } from 'react';
import ModalForm from '../Modal/Modal';
import ProposalCard_V2 from './ProposalCard_V2';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import CustomRichText from '../CustomRichText';
export interface ProposalCardBlockProps {
  id?: string;
  title: ReactNode | SerializedEditorState;
  subtitle?: ReactNode | SerializedEditorState;
  title_2?: ReactNode | SerializedEditorState;
  cardList: Array<{
    title: ReactNode | SerializedEditorState;
    subtitle?: ReactNode | SerializedEditorState;
  }>;
  color?: 'violet' | 'green' | 'blue';
  showBtn?: boolean;
  buttonText?: string;
  btnTag?: string;
}

export default function ProposalCardBlock_V2({
  title,
  subtitle,
  cardList,
  id,
  color = 'green',
  title_2,
  showBtn = false,
  buttonText = '',
  btnTag,
}: ProposalCardBlockProps) {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  const backgroundColorClass =
    {
      green: 'custom-gradient-green',
      blue: 'custom-gradient-blue',
      violet: 'custom-gradient-violet',
    }[color] || 'custom-gradient-green';
  return (
    <>
      <div
        id={id}
        data-meta="ProposalCardBlock_V2"
        className={`container mx-auto sm:px-5 my-5 flex flex-col justify-center rounded-3xl`}
      >
        <CustomRichText
          data={title}
          tag="h2"
          className="text-center text-3xl font-bold tracking-tight text-white sm:text-6xl mb-4 sm:mb-8"
        />
        {subtitle && (
          <>
            {' '}
            <CustomRichText
              data={subtitle}
              tag="div"
              className="text-center mt-6 text-base lg:text-lg md:leading-6 lg:leading-8 text-white"
            />{' '}
          </>
        )}

        {title_2 && (
          <CustomRichText
            data={title_2}
            tag="div"
            className="mt-4 text-3xl font-bold text-white text-center"
          />
        )}
        <div className="grid grid-cols-1 gap-2 lg:grid-cols-2 lg:gap-4 py-14">
          {cardList.map((item, index) => (
            <ProposalCard_V2 key={index} title={item.title} subtitle={item.subtitle} />
          ))}
        </div>
        {showBtn && (
          <div className="flex justify-center">
            <button
              onClick={openForm}
              className={`pl-8 pr-1 py-1 text-lg font-bold text-white uppercase rounded-full  ring-violet-500 ring-1 flex gap-2 items-center`}
            >
              <span className="max-sm:text-sm">{buttonText}</span>
              <div className={`rounded-full ${backgroundColorClass}`}>
                <ArrowUpRightIcon className="text-white h-4 w-4 m-2" />
              </div>
            </button>
          </div>
        )}
      </div>
      {isFormOpen && (
        <ModalForm closeForm={closeForm} btnMeta={{ tag: btnTag ?? '' }} color={color} />
      )}
    </>
  );
}
